<div class="main-content">
  <div class="container-fluid">
    <div class="form-container">
      <div class="card">
        <div class="card-header">
          <h4>{{ id ? 'Editar' : 'Crear' }} Servicio</h4>
        </div>
        <div class="card-body">
          <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <!-- Campo Nombre -->
            <div class="form-group">
              <label for="name">Nombre *</label>
              <input type="text" class="form-control" id="name" formControlName="name">
              <div class="error-message" *ngIf="form.get('name')?.invalid && form.get('name')?.touched">
                El nombre es requerido
              </div>
            </div>

            <!-- Campo Valor -->
            <div class="form-group">
              <label for="value">Value</label>
              <input type="number" class="form-control" id="value" formControlName="value" min="0">
              <div class="error-message" *ngIf="form.get('value')?.invalid && form.get('value')?.touched">
                <span *ngIf="form.get('value')?.errors?.['required']">El valor es requerido</span>
                <span *ngIf="form.get('value')?.errors?.['min']">El valor debe ser mayor o igual a 0</span>
              </div>
            </div>

            <!-- Campo Estado -->
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="status" formControlName="status">
                <label class="custom-control-label" for="status">Activo</label>
              </div>
            </div>

            <!-- Botones -->
            <div class="buttons-container">
              <button type="button" class="btn btn-default" (click)="onCancel()">
                Cancelar
              </button>
              <button type="submit" class="btn btn-primary" [disabled]="form.invalid || loading">
                {{ id ? 'Actualizar' : 'Guardar' }}
              </button>
            </div>
          </form>
        </div>
      </div>

      <!-- Loading Overlay -->
      <div class="loading-overlay" *ngIf="loading">
        <mat-spinner diameter="50"></mat-spinner>
      </div>
    </div>
  </div>
</div>
